<template>
  <div>
    <h3>General description</h3>
    <p>
      The constellation generation mission is based on geometrical
      considerations to design a constellation based on the following criteria:
    </p>
    <ul>
      <li><b>Altitude</b> : the operating altitude.</li>
      <li><b>Payload</b> : the payload.</li>
      <li>
        <b>Points of interest</b> : the points of interest on the Earth surface.
      </li>
      <li>
        <b>Maximum allowed revisit time</b> : the maximum revisit time allowed
        for the points of interest.
      </li>
    </ul>

    <h3>Options</h3>
    <p>The constellation generation provides different options listed below:</p>
    <ul>
      <li>
        <b>Maximum number of planes</b> : the maximum number of planes of the
        constellation to be generated.
      </li>
      <li>
        <b>Sunlight considerations</b> : takes into account the enlightenment of
        the latitudes of interest to generate a suitable constellation.
      </li>
      <li>
        <b>Sun zenith angle</b> : the maximum angle of incidence of the solar
        rays to consider a point potentially visible by a spacecraft.
      </li>
    </ul>

    <h3>Hypotheses</h3>
    <p>The underlying assumptions for this module are the following:</p>
    <ul>
      <li>The Earth geometry is considered spherical</li>
      <li>Only circular orbits are considered</li>
      <li>
        The only perturbation taken into account is the oblateness of the Earth
        (<katex-element expression="J_2" /> harmonic of the potential)
      </li>
      <li>Payloads have circular fields of regard</li>
      <li>Earth meshes are rectangular</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationOptimizationMission'
}
</script>
